import { ADMIN_GROUPS, type AdminRole } from '#shared/adminPermissions';
import { isLocalDemoMode } from '#src/utils/localDemo';

const LOCAL_ADMIN_SESSION_KEY = 'amsleighpfa_local_admin';
export const LOCAL_ADMIN_TOKEN = 'local-admin-token';
export const LOCAL_ADMIN_EMAIL = 'local-admin@example.com';
export const LOCAL_ADMIN_ROLE: AdminRole = ADMIN_GROUPS.superAdmin;

export const hasLocalAdminSession = (): boolean => {
  if (!isLocalDemoMode() || typeof sessionStorage === 'undefined') {
    return false;
  }
  return sessionStorage.getItem(LOCAL_ADMIN_SESSION_KEY) === '1';
};

export const enterLocalAdminSession = (): void => {
  sessionStorage.setItem(LOCAL_ADMIN_SESSION_KEY, '1');
};

export const exitLocalAdminSession = (): void => {
  sessionStorage.removeItem(LOCAL_ADMIN_SESSION_KEY);
};
